/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPlanningResponse } from '../../models/get-planning-response';

export interface PlanningsControllerGetPlanning$Params {
  id: string;
}

export function planningsControllerGetPlanning(http: HttpClient, rootUrl: string, params: PlanningsControllerGetPlanning$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlanningResponse>> {
  const rb = new RequestBuilder(rootUrl, planningsControllerGetPlanning.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPlanningResponse>;
    })
  );
}

planningsControllerGetPlanning.PATH = '/planning-projects/v1/projects/variants/plannings/{id}';
